/**
 * 判定の絞り込みで使う値。API 語彙（include_user_selected_values）に合わせる。
 * - selected:    該当（is_user_selected = true）
 * - not_selected: 非該当（is_user_selected = false）
 * - undecided:   未判定（is_user_selected = null）
 */
export const JUDGEMENT_FILTER_VALUES = ['selected', 'not_selected', 'undecided'] as const;
export type JudgementFilterValue = (typeof JUDGEMENT_FILTER_VALUES)[number];
